(() => {
  if (window.europelabCoaReady) return;
  window.europelabCoaReady = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-coa-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-coa-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const dialog = event.target;
    if (dialog instanceof HTMLDialogElement && dialog.matches('[data-product-coa]')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
})();
